import { Icons } from '@agro-club/agroclub-shared'
import { ListRequestParams } from 'modules/domain/types'
import { FC, useState } from 'react'
import styled from 'styled-components'
import { AButton } from 'views/components/Analytics'
import { RemoveTripModal } from '../../../../../CarriersKR/RemoveTripModal/RemoveTripModal'

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
`

type Props = {
  tripId: string
  listRequestParams: ListRequestParams
  setListRequestParams: (params: ListRequestParams) => void
}
export const OnApprovalTripCell: FC<Props> = ({ tripId, listRequestParams, setListRequestParams }) => {
  const [removeModal, setRemoveModal] = useState(false)

  return (
    <ButtonWrapper>
      <AButton
        id="removeTrip"
        size="small"
        color="destruct"
        Icon={Icons.IconRemove}
        onClick={() => setRemoveModal(true)}
      />
      {removeModal && (
        <RemoveTripModal
          onClose={setRemoveModal}
          tripId={tripId}
          onSuccess={() => setListRequestParams({ ...listRequestParams })}
        />
      )}
    </ButtonWrapper>
  )
}
